class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class DetailsHoverToggle extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    // FIXME: TEMPORARY TESTING TURNING OFF TOGGLE
    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.details || !this.summary) return;
    this.reveal = this.details.querySelector('.mega-menu__reveal');

    this.summary.addEventListener('mouseenter', () => {
      if (!this.details.open) this.playReveal();
      this.details.setAttribute('open', true);
      // this.details.setAttribute('open', ''); - Alex: testing Tailwind animation
    });

    this.details.addEventListener('mouseleave', () => {
      this.details.removeAttribute('open');
    });

    // Click/keyboard (Enter/Space fire click): <details> opens after this handler, in the same task
    this.summary.addEventListener('click', () => {
      if (!this.details.open) this.playReveal();
    });
  }

  // Mega menu reveal, started in the same task that opens the menu so the fully open state is
  // never painted first. (A CSS animation keyed off [open] won't reliably restart, and the
  // 'toggle' event fires too late - after a frame has already rendered.)
  playReveal() {
    if (!this.reveal) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.reveal.animate(
      [{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0 0)' }],
      { duration: 350, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );
  }
}

customElements.define('details-hover-toggle', DetailsHoverToggle);